import React, { Component } from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { restoreConfigVersionAction } from '../actions';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';

class PayerVersions extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ marginTop: '10px' }}>
        <h2>Previous Versions</h2>
        <div className="config_versions">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Author</th>
                <th>Created At</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {(this.props.versions || [])
                .filter(version => version && version.version_id)
                .map(version => (
                  <tr key={version.version_id}>
                    <td>{version.version_id}</td>
                    <td>{version.author_name}</td>
                    <td>
                      <time dateTime={version.created_at}>
                        {moment(version.created_at).format('LLL')}
                      </time>
                    </td>
                    <td className="actions">
                      <a
                        className="action"
                        style={{ cursor: 'pointer' }}
                        href={`/payers/${encodeURIComponent(this.props.payer_id)}/versions/${encodeURIComponent(version.version_id)}`}
                      >
                        View
                      </a>
                    </td>
                  </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { restoreConfigVersionAction };

PayerVersions.propTypes = {
  payer_id:                   PropTypes.number,
  versions:                   PropTypes.array,
  restoreConfigVersionAction: PropTypes.func
};

export default connect(null, mapDispatchToProps)(PayerVersions);
